// extracted by mini-css-extract-plugin
export default {"contentCard":"ContentCard_contentCard__bzqho","contentCard_header":"ContentCard_contentCard_header__y6ktS","contentCard_main":"ContentCard_contentCard_main__dq9PX"};